"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCandidateSummary = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a summary of a Steam user, if they exist.
 * User is identified by their profile's URL. Can be either ID profile of PROFILES profile.
 * Does not have to be a MasochistME member.
 *
 * ## Usage
 *
 * ```ts
 * const steamUrl: string = "https://steamcommunity.com/id/ARCYVILK";
 * const candidate: Candidate[] = await sdk.getCandidateSummary({ steamUrl });
 * ```
 *
 * @param params.steamId   - (Optional) Steam ID of the requested member.
 * @param params.discordId - (Optional) Discord ID of the requested member.
 */
const getCandidateSummary = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { steamUrl } = params;
    const url = `${BASE_URL}/candidate/scout`;
    const candidateResponse = yield axios_1.default.post(url, { steamUrl }, { validateStatus: () => true });
    const { status, data } = candidateResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getCandidateSummary = getCandidateSummary;
